var validString = /[0-9]+(rem|px|vh|em|vmin|vmax|%)/;
export var validateLength = function(value, type) {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        if (validString.test(value)) {
            return value;
        }
    }
    console.warn("Invalid value for ".concat(type, " property.\n      Please make sure you are using a valid css unit if passing the height in as a string."));
    return undefined;
};
export var calculateMinHeight = function(height) {
    var value = validateLength(height, 'height');
    if (typeof value === 'string') {
        return "calc(".concat(height, " * 0.4)");
    }
    if (typeof value === 'number') {
        return height * 0.4;
    }
    return 0;
};
